
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pga-of-america/[slug]",
      function () {
        return require("private-next-pages/pga-of-america/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pga-of-america/[slug]"])
      });
    }
  